import { useLocation, useParams } from 'react-router-dom';
import { toNumber } from 'lodash';
import { FrEventDetailsTab } from '../types';

export function useGetEventIdAndTabNameFromParams(): {
    eventId?: number;
    requestedTab?: FrEventDetailsTab;
} {
    const params = useParams();
    const location = useLocation();

    const eventId = params.eventId ? toNumber(params.eventId) : undefined;

    return { eventId, requestedTab: location.state?.frEventDetailsTabName };
}
